// @owners { team: patients-team }
import React from 'react';
import { getCompanyPhone } from '~shared/config/getCompanyPhone';

export const Phone = () => {
  return <a href={`tel:${getCompanyPhone()}`}>{getCompanyPhone()}</a>;
};
